import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";


interface SendNewslettsDTO {
    email: string;
}

interface NewsletterResponse extends ApiError {
    id: string;
    email: string;
    createdAt: string;
    updatedAt: string;
}
export const SendNewsletter = (data: SendNewslettsDTO): Promise<NewsletterResponse> => {
    return axios.post("/news-letter/create", data)
        .then(response => response.data as NewsletterResponse);
};